const INDENT_CLASSES = [
  '', // level 0
  'border-l-2 border-border dark:border-[#3a3f47] pl-1 sm:pl-4', // level 1
  'border-l-2 border-border dark:border-[#3a3f47] pl-2 sm:pl-6', // level 2
  'border-l-2 border-border dark:border-[#3a3f47] pl-2 sm:pl-7', // level 3
  'border-l-2 border-border dark:border-[#3a3f47] pl-2 sm:pl-8', // level 4
  'border-l-2 border-border dark:border-[#3a3f47] pl-2 sm:pl-9', // level 5
  'border-l-2 border-border dark:border-[#3a3f47] pl-2 sm:pl-10', // level 6
  'border-l-2 border-border dark:border-[#3a3f47] pl-2 sm:pl-11', // level 7
  'pl-0 sm:pl-6', // level 8+
] as const;

export function getCommentIndentClass(level: number): string {
  return INDENT_CLASSES[Math.min(level, 8)] || INDENT_CLASSES[8];
}
